/** The fixed BrowseEntities document (persisted-query list, sites#277), shared by
 * EntityIndex lists and the /districts/ map's graph inventory (sites#467). */
export const BROWSE_ENTITIES_QUERY = `
query BrowseEntities($entityType: EntityType!, $page: Int!, $sortOrder: SortOrder!, $sortField: String, $filter: String, $filters: [EntityFilterInput!]) {
  browseEntities(entityType: $entityType, page: $page, pageSize: 50, sortOrder: $sortOrder, sortField: $sortField, filter: $filter, filters: $filters) {
    results {
      id
      type
      name
      score
      state
      city
      party
      office
      district
      metadata
      affinityDem
      affinityRep
    }
    total
    page
    pageSize
    hasMore
  }
}
`;
